import rem from '@/utils/rem';
import { Icon, IconButton, IconButtonProps } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { BsStar, BsStarFill } from 'react-icons/bs';

type Props = {
  starred: boolean;
  onClick: () => void;
};

const IconStarred = ({ starred, onClick, ...rest }: Props & Partial<IconButtonProps>) => {
  const { t } = useTranslation('IconStarred');
  return (
    <IconButton
      border="none"
      aria-checked={starred}
      aria-label={starred ? t('ariaLabels.unstarAction') : t('ariaLabels.starAction')}
      icon={<Icon as={starred ? BsStarFill : BsStar} boxSize={rem(14)} color="text-primary" />}
      isActive={starred}
      onClick={onClick}
      role="checkbox"
      variant="secondary"
      {...rest}
    />
  );
};

export default IconStarred;
